/**
 * `useBusSubscription` — живучие NATS-подписки компонента.
 *
 * Проблема, которую решает (ночной аудит 16.07): ручные `bus.subscribe` в
 * `onMounted` с гейтом `if (!natsStore.bus) return` умирают навсегда после
 * релогина — `natsStore.connect()` создаёт НОВЫЙ инстанс `NatsBus`
 * (SessionExpiredDialog, истечение JWT ~сутки), а старые подписки остаются
 * висеть на закрытом. `useLiveCollection` для этого держит
 * `watch(() => natsStore.bus, ...)` — здесь тот же паттерн, вынесенный для
 * компонентов, которым нужен не живой снимок коллекции, а голые события.
 *
 * Колбэк вызывается для КАЖДОГО актуального инстанса шины (в т.ч. появившегося
 * позже монтирования — гонка с NATS-коннектом при старте приложения) и обязан
 * вернуть список подписок; их снятие (при смене шины и при unmount) — забота
 * композабла.
 */
import { onScopeDispose, watch } from 'vue'
import { useNatsStore } from './nats-store'
import type { NatsBus } from './nats-bus'

interface Unsubscribable {
  unsubscribe: () => void
}

export const useBusSubscription = (subscribe: (bus: NatsBus) => Unsubscribable[]): void => {
  const natsStore = useNatsStore()

  let active: Unsubscribable[] = []
  const teardown = (): void => {
    for (const sub of active) sub.unsubscribe()
    active = []
  }

  watch(
    () => natsStore.bus,
    (bus) => {
      teardown()
      if (bus) active = subscribe(bus)
    },
    { immediate: true },
  )

  onScopeDispose(teardown)
}
